import { render, staticRenderFns } from "./DataBoard.vue?vue&type=template&id=8b1b8234&scoped=true&"
import script from "./DataBoard.vue?vue&type=script&lang=ts&"
export * from "./DataBoard.vue?vue&type=script&lang=ts&"
import style0 from "../style.scss?vue&type=style&index=0&id=8b1b8234&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1b8234",
  null
  
)

export default component.exports